"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _bar = require("cccisd-nivo/bar");
var _util = require("./util.js");
var _style = _interopRequireDefault(require("./style.css"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GraphQLBarChart = function GraphQLBarChart(props) {
  var formatData = function formatData(raw) {
    var labelPath = props.labelPath,
      valuePath = props.valuePath,
      valuePrecision = props.valuePrecision,
      labels = props.labels,
      groups = props.groups,
      breakdownPath = props.breakdownPath,
      breakdownLabelPath = props.breakdownLabelPath,
      breakdownValuePath = props.breakdownValuePath,
      ignoreLabels = props.ignoreLabels,
      ignoreValues = props.ignoreValues;
    var processed = raw.filter(function (row) {
      var rowValue = (0, _util.dotIndex)(valuePath, row);
      if (ignoreValues.includes(rowValue)) {
        return false;
      }
      var rowLabel = (0, _util.dotIndex)(labelPath, row);
      return labels.length > 0 ? labels.includes(rowLabel) : !ignoreLabels.includes(rowLabel);
    }).map(function (row) {
      var newRow = {};
      var rowLabel = (0, _util.dotIndex)(labelPath, row);
      var rowValue = (0, _util.dotIndex)(valuePath, row);
      newRow.id = rowLabel;
      newRow.label = rowLabel;
      newRow.value = (0, _util.setPrecision)(rowValue, valuePrecision);
      if (groups.length > 0) {
        groups.forEach(function (group) {
          var itemLabel = group.label;
          var itemValue = (0, _util.dotIndex)(group.path, row);
          newRow[itemLabel] = (0, _util.setPrecision)(itemValue, valuePrecision);
        });
      } else if (breakdownPath !== '') {
        var breakdown = (0, _util.dotIndex)(breakdownPath, row);
        if (typeof breakdown === 'undefined') {
          console.error('Cannot find breakdownPath ' + breakdownPath + ' in dataset');
        }
        breakdown.forEach(function (item) {
          var itemLabel = (0, _util.dotIndex)(breakdownLabelPath, item);
          var itemValue = (0, _util.dotIndex)(breakdownValuePath, item);
          newRow[itemLabel] = (0, _util.setPrecision)(itemValue, valuePrecision);
        });
      }
      return newRow;
    });
    labels.forEach(function (label) {
      var labelFound = processed.filter(function (row) {
        return row.id === label;
      }).length;
      if (labelFound === 0) {
        processed.push({
          id: label,
          label: label,
          value: 0
        });
      }
    });
    return processed;
  };
  var processData = function processData(breakdownKeys) {
    var data = props.data,
      rollupCount = props.rollupCount,
      rollupAtEnd = props.rollupAtEnd,
      rollupLabel = props.rollupLabel,
      reverseData = props.reverseData,
      breakdownPath = props.breakdownPath,
      breakdownLabelPath = props.breakdownLabelPath,
      breakdownValuePath = props.breakdownValuePath;
    var formattedData = formatData(data);
    if (formattedData.length <= rollupCount) {
      return sortData(_objectSpread(_objectSpread({}, props), {}, {
        data: formattedData
      }));
    }
    var sorted = sortData({
      data: formattedData,
      orderByValue: true
    });
    var newData = sorted.slice(0, rollupCount - 1);
    var otherData = sorted.slice(rollupCount - 1);
    var accumulated = otherData.reduce((0, _util.totalReducer)('value'), 0);
    var rollupData = {};
    rollupData.id = rollupLabel;
    rollupData.label = rollupLabel;
    rollupData.value = accumulated;
    if (breakdownPath !== '') {
      breakdownKeys.forEach(function (key) {
        rollupData[key] = otherData.reduce(function (cume, item) {
          var match = (0, _util.dotIndex)(breakdownPath, item).filter(function (obj) {
            return (0, _util.dotIndex)(breakdownLabelPath, obj) === key;
          });
          if (match.length > 0) {
            return cume + (0, _util.dotIndex)(breakdownValuePath, match[0]);
          }
          return cume;
        }, 0);
      });
    }
    newData.push(rollupData);
    if (!rollupAtEnd) {
      newData.sort((0, _util.sortByValue)('value')).reverse();
    }
    if (reverseData) {
      return newData.reverse();
    }
    return newData;
  };
  var sortData = function sortData(_ref) {
    var data = _ref.data,
      orderByLabel = _ref.orderByLabel,
      orderByValue = _ref.orderByValue,
      orderByNumeric = _ref.orderByNumeric,
      reverseData = _ref.reverseData;
    var newData = data;
    var labels = props.labels;
    var order = {};
    var index = 1;
    var _iterator = _createForOfIteratorHelper(labels),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var label = _step.value;
        order[label] = index;
        index++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (orderByLabel) {
      if (orderByNumeric) {
        newData.sort((0, _util.sortByValueNumeric)('label'));
      } else {
        newData.sort((0, _util.sortByValue)('label'));
      }
    } else if (orderByValue) {
      if (orderByNumeric) {
        newData.sort((0, _util.sortByValueNumeric)('value'));
      } else {
        newData.sort((0, _util.sortByValue)('value'));
      }
    } else {
      // preserve order of labels
      newData.sort(function (a, b) {
        return order[a.label] - order[b.label];
      });
    }
    if (reverseData) {
      newData.reverse();
    }
    return newData;
  };
  var renderTotal = function renderTotal(chartData) {
    var totalLabel = props.totalLabel,
      showTotal = props.showTotal,
      data = props.data;
    var chartTotal = chartData.reduce((0, _util.totalReducer)('value'), 0);
    var skippedTotal = (0, _get2["default"])((0, _find2["default"])(data, ['value', null]), 'valueCount', 0);
    if (!showTotal) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("h5", {
      className: _style["default"].total
    }, totalLabel, ":\xA0", chartTotal, skippedTotal > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), "Skipped:\xA0", skippedTotal));
  };
  var renderBar = function renderBar(chartData, breakdownKeys) {
    var width = props.width,
      height = props.height,
      barHeight = props.barHeight,
      nivo = props.nivo,
      maxLabelLength = props.maxLabelLength,
      labelTailLength = props.labelTailLength;
    var adjustedHeight = height;
    if (height === null) {
      if (nivo.layout === 'horizontal') {
        var padding = nivo.padding || 0.5;
        var numItems = chartData.length;
        var topMargin = 50;
        if (nivo.margin && typeof nivo.margin.top !== 'undefined') {
          topMargin = nivo.margin.top;
        }
        var bottomMargin = 50;
        if (nivo.margin && typeof nivo.margin.bottom !== 'undefined') {
          bottomMargin = nivo.margin.bottom;
        }
        adjustedHeight = topMargin + bottomMargin + barHeight * numItems + barHeight * padding * (numItems - 1);
        nivo.axisLeft = {
          format: function format(value) {
            return (0, _util.shorten)(value, maxLabelLength, labelTailLength);
          },
          tickRotation: -30
        };
      } else {
        adjustedHeight = '600px';
        nivo.axisBottom = {
          format: function format(value) {
            return (0, _util.shorten)(value, maxLabelLength, labelTailLength);
          },
          tickRotation: -30
        };
      }
    }
    if (typeof nivo.maxValue === 'function') {
      var computedMaxValue = nivo.maxValue(chartData);
      nivo.maxValue = computedMaxValue;
    }
    var wrapperProps = {
      width: width,
      height: adjustedHeight
    };
    var defaultProps = {
      colors: {
        scheme: 'category10'
      },
      borderColor: {
        from: 'color',
        modifiers: [['darker', 1.6]]
      },
      labelTextColor: '#FFFFFF',
      animate: true,
      motionStiffness: 90,
      motionDamping: 15
    };
    if (breakdownKeys.length > 0) {
      defaultProps.keys = breakdownKeys;
      defaultProps.margin = {
        top: 50,
        right: 150,
        bottom: 50,
        left: 180
      };
    } else {
      defaultProps.tooltip = function (_ref2) {
        var id = _ref2.id,
          value = _ref2.value,
          color = _ref2.color,
          indexValue = _ref2.indexValue;
        return /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: color
          }
        }, indexValue, ":"), " ", value);
      };
      defaultProps.legends = [];
      if (nivo.layout === 'horizontal') {
        defaultProps.margin = {
          top: 50,
          right: 50,
          bottom: 50,
          left: 180
        };
      } else {
        defaultProps.margin = {
          top: 50,
          right: 20,
          bottom: 50,
          left: 50
        };
      }
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: wrapperProps
    }, renderTotal(chartData), /*#__PURE__*/_react["default"].createElement(_bar.ResponsiveBar, _extends({}, defaultProps, nivo, {
      data: chartData
    })));
  };
  var findBreakdownKeys = function findBreakdownKeys() {
    var data = props.data,
      groups = props.groups,
      breakdownKeys = props.breakdownKeys,
      breakdownPath = props.breakdownPath,
      breakdownLabelPath = props.breakdownLabelPath;
    var keys = [];
    if (groups.length > 0) {
      groups.forEach(function (group) {
        keys.push(group.label);
      });
      return keys;
    }
    if (breakdownPath === '') {
      return [];
    }
    if (breakdownKeys.length > 0) {
      return breakdownKeys;
    }
    data.forEach(function (row) {
      (0, _util.dotIndex)(breakdownPath, row).forEach(function (item) {
        var key = (0, _util.dotIndex)(breakdownLabelPath, item);
        if (!keys.includes(key)) {
          keys.push(key);
        }
      });
    });
    return keys;
  };
  var breakdownKeys = findBreakdownKeys();
  var chartData = processData(breakdownKeys);
  if (chartData === null) {
    return null;
  }
  return renderBar(chartData, breakdownKeys);
};
GraphQLBarChart.propTypes = {
  data: _propTypes["default"].array.isRequired,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  barHeight: _propTypes["default"].number,
  labelPath: _propTypes["default"].string,
  valuePath: _propTypes["default"].string,
  valuePrecision: _propTypes["default"].number,
  labels: _propTypes["default"].array,
  ignoreLabels: _propTypes["default"].array,
  ignoreValues: _propTypes["default"].array,
  groups: _propTypes["default"].array,
  breakdownPath: _propTypes["default"].string,
  breakdownLabelPath: _propTypes["default"].string,
  breakdownValuePath: _propTypes["default"].string,
  breakdownKeys: _propTypes["default"].array,
  maxLabelLength: _propTypes["default"].number,
  labelTailLength: _propTypes["default"].number,
  rollupCount: _propTypes["default"].number,
  rollupAtEnd: _propTypes["default"].bool,
  rollupLabel: _propTypes["default"].string,
  orderByLabel: _propTypes["default"].bool,
  orderByValue: _propTypes["default"].bool,
  orderByNumeric: _propTypes["default"].bool,
  reverseData: _propTypes["default"].bool,
  showTotal: _propTypes["default"].bool,
  totalLabel: _propTypes["default"].string,
  showFrequencyTable: _propTypes["default"].bool,
  frequencyTable: _propTypes["default"].object,
  nivo: _propTypes["default"].object
};
GraphQLBarChart.defaultProps = {
  width: '100%',
  height: null,
  barHeight: 30,
  labelPath: 'value',
  valuePath: 'valueCount',
  valuePrecision: 1,
  labels: [],
  ignoreLabels: [],
  ignoreValues: [],
  groups: [],
  breakdownPath: '',
  breakdownLabelPath: 'value',
  breakdownValuePath: 'valueCount',
  breakdownKeys: [],
  maxLabelLength: 36,
  labelTailLength: 10,
  rollupCount: 11,
  rollupAtEnd: true,
  rollupLabel: 'All others',
  orderByLabel: false,
  orderByValue: false,
  orderByNumeric: false,
  reverseData: false,
  showTotal: false,
  totalLabel: 'Total',
  showFrequencyTable: false,
  frequencyTable: {},
  nivo: {}
};
var _default = exports["default"] = GraphQLBarChart;